import React from 'react';

function Loader() {
  return (
    <div id="preloader">
      <div id="loader"></div>
    </div>
  );
}

export default Loader;